<div class="modal-overlay">
  <div class="modal-content">
    <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t:'Close'" (click)="closeModal()">&times;</button>

    <div class="modal-header">
      <h2>{{ mode === 'edit' ? ('expense.modalEditTitle' | t:'Edit Expense') : ('expense.modalNewTitle' | t:'New Expense') }}</h2>
    </div>

    <form class="expense-form" (ngSubmit)="submitForm()">
      <div class="form-row three-col">
        <app-common-dropdown
          [dropdownObj]="houseDropdownObj"
          [value]="expense.houseId"
          (valueChange)="onHouseChange($event)"
          (optionsLoaded)="onHouseOptionsLoaded($event)"
        ></app-common-dropdown>

        <app-common-dropdown
          [dropdownObj]="flatDropdownWithNoFlatOption"
          [requestFilters]="flatDropdownFilters"
          [value]="selectedFlatValue"
          (valueChange)="onFlatChange($event)"
          (optionsLoaded)="onFlatOptionsLoaded($event)"
        ></app-common-dropdown>

        <app-common-dropdown
          [dropdownObj]="expenseHeadDropdownObj"
          [value]="expense.expenseHeadId"
          (valueChange)="onExpenseHeadChange($event)"
          (optionsLoaded)="onExpenseHeadOptionsLoaded($event)"
        ></app-common-dropdown>
      </div>

      <div class="form-row two-col">
        <div class="form-group">
          <label>{{ 'expense.expenseDate' | t:'Expense Date' }} *</label>
          <div class="date-input-wrap">
            <input
              type="text"
              class="date-input"
              [(ngModel)]="expense.expenseDate"
              name="expenseDate"
              [placeholder]="'placeholder.selectDate' | t:'Select date'"
              readonly
              (click)="picker.open()"
              required
            />
            <button type="button" class="date-picker-btn" [attr.aria-label]="'placeholder.selectDate' | t:'Pick date'" (click)="picker.open()">
              <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path d="M7 2a1 1 0 0 1 1 1v1h8V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1Zm13 8H4v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8ZM5 6a1 1 0 0 0-1 1v1h16V7a1 1 0 0 0-1-1H5Z"/>
              </svg>
            </button>
            <input
              matInput
              [matDatepicker]="picker"
              [value]="matDateValue"
              class="mat-date-anchor"
              (dateChange)="onDateSelected($event)"
              tabindex="-1"
              aria-hidden="true"
            />
            <mat-datepicker #picker></mat-datepicker>
          </div>
        </div>

        <div class="form-group">
          <label>{{ 'expense.expenseAmount' | t:'Expense Amount' }} *</label>
          <input
            type="number"
            min="1"
            [(ngModel)]="expense.expenseAmount"
            name="expenseAmount"
            [placeholder]="'placeholder.typeAmount' | t:'Type amount'"
            required
          />
        </div>
      </div>

      <div class="form-group">
        <label>{{ 'expense.remarks' | t:'Remarks' }}</label>
        <textarea
          [(ngModel)]="expense.remarks"
          name="remarks"
          rows="4"
          [placeholder]="'placeholder.typeRemarksOptional' | t:'Type remarks (optional)'"
        ></textarea>
      </div>

      <div class="form-feedback" *ngIf="error">
        <div class="form-message error" *ngIf="error">{{ error }}</div>
      </div>

      <div class="form-actions">
        <button class="PositiveBTN" type="submit" [disabled]="isSubmitting">
          {{ isSubmitting ? ('common.saving' | t:'Saving...') : (mode === 'edit' ? ('expense.updateButton' | t:'Update Expense') : ('expense.addButton' | t:'Add Expense')) }}
        </button>
      </div>
    </form>
  </div>
</div>
